import {
    CANNED_QUESTION_EMAIL_ADDRESS,
    CANNED_QUESTION_FIRST_NAME,
    CANNED_QUESTION_LAST_NAME,
} from '../../../containers/checkout/constants';
import { FormSurveyAnswer } from '../../../models/forms';

const basicInfoQuestions: string[] = [
    CANNED_QUESTION_EMAIL_ADDRESS,
    CANNED_QUESTION_FIRST_NAME,
    CANNED_QUESTION_LAST_NAME,
];

export const removeEmptyBuyerDetails = (
    surveryQuestions: Array<FormSurveyAnswer>,
) =>
    surveryQuestions.filter(
        ({ question_id, answer }: FormSurveyAnswer) =>
            !basicInfoQuestions.includes(question_id) ||
            (basicInfoQuestions.includes(question_id) && answer !== null),
    );
